<script lang="ts" setup>
import { Button } from '@brighterly/lib-lumee-ui'

import { useSubscriptionStore } from '@stores/subscription'

import amplitudeConf from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

import { LoaderBlockDomain } from '@UI/Loaders/LoaderBlockDomain'

defineOptions({
  name: 'ModalRetryProcessing',
})

const AppModal = defineAsyncComponent(() => import('@UI/Modals/AppModal').then((module) => module.AppModal))

const subscriptionStore = useSubscriptionStore()

const title = 'Payment is processing...'

onMounted(() => {
  trackEvent(amplitudeConf.events.popupView, {
    popup_name: 'retry_payment_processing',
    popup_title: title,
  })
})

const setSubmit = (): void => {
  trackEvent(amplitudeConf.events.clickButton, {
    button_name: 'return_to_homepage',
    button_text: 'Return to Homepage',
  })

  subscriptionStore.setModalRetryPaymentProcessing(false)
}
</script>

<template>
  <AppModal
    :show-button-close="false"
  >
    <template #contentSlot>
      <div class="rp">
        <div class="rp__loader">
          <LoaderBlockDomain />
        </div>
        <div class="rp__info">
          <div
            class="rp__content"
          >
            <h4 class="rp__heading-s btly-text-heading-s">
              {{ title }}
            </h4>
            <div class="rp__body-l btly-text-body-l">
              This may take some time to complete.
              <br>
              We'll notify you once it's done.
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #bottomSlot>
      <Button
        view="secondary"
        fill
        text="Return to Homepage"
        @click="setSubmit"
      />
    </template>
  </AppModal>
</template>

<style scoped lang="scss" src="@scss/components/Modals/RetryPayment/ModalRetryProcessing.scss" />
